import React from 'react';

import { moneyStrings } from '@data/money';
import { paymentDetailsStrings } from '@data/paymentSlip';
import { ArrivalNoticePaymentInfo } from '@models/next/ArrivalNotice';
import { PaymentDetails, PaymentDetailsHelper } from '@models/next/PaymentSlip';
import { makeMuiStyles, useCommonStyles } from '@styles';
import { pipe } from 'remeda';

const useStyles = makeMuiStyles((theme, common) => ({
  arrivalNoticePaymentInfoDisplayContainer: {
    ...common.textGray700,
    ...common.middleText,
    display: 'grid',
    gridTemplateColumns: 'max-content repeat(6, auto)',
    '& > div': {
      padding: '10px 10px',
    },
    '& > *[role="head"]': {
      ...common.backgroundPrimaryAlpha20,
    },
    '& > *[role="data"]': {
      ...common.backgroundPrimaryAlpha5,
    },
  },
}));

export const ArrivalNoticePaymentInfoDisplay: React.FC<{
  paymentInfo: ArrivalNoticePaymentInfo;
}> = ({ paymentInfo }) => {
  const classes = {
    ...useCommonStyles(),
    ...useStyles(),
  };

  const renderLabel = (key: keyof PaymentDetails) => {
    return <div role="head">{PaymentDetails.shape[key].getFormMeta().label}</div>;
  };

  return (
    <div className={classes.arrivalNoticePaymentInfoDisplayContainer}>
      <div role="head">No.</div>
      {renderLabel('name')}
      {renderLabel('memo')}
      {renderLabel('unit_price')}
      <div role="head">
        {paymentDetailsStrings.unit_num}・{paymentDetailsStrings.unit_num_type}
      </div>
      {renderLabel('excise_tax_type')}
      <div role="head">{paymentDetailsStrings.non_tax_amount}</div>

      {paymentInfo.payment_details.map((d, i) =>
        pipe(
          d,
          (d) => new PaymentDetailsHelper(d),
          (h) => (
            <React.Fragment key={i}>
              <div role="data">{i + 1}</div>
              <div role="data">{d.name}</div>
              <div role="data">{d.memo}</div>
              <div role="data">{moneyStrings.formatYenFront(d.unit_price)}</div>
              <div role="data">
                {d.unit_num}・{d.unit_num_type}
              </div>
              <div role="data">{d.excise_tax_type}</div>
              <div role="data">{moneyStrings.formatYenFront(h.getTaxExcludedTotalPrice())}</div>
            </React.Fragment>
          ),
        ),
      )}
    </div>
  );
};
